// hooks/useApplyFilters.js
import { useCallback } from 'react';
import { API_CONSTANTS } from '../utils/constants';
import { createSearchParams } from '../utils/helpers';


export const useApplyDashboardFilter = ({
    filters,
    updateFilters,
    fetchSemanticRCA2,
    fetchSpatialData,
    fetchAllCompanyDetails,
    fetchUserData,
    fetchCategories,
    // fetchCategoryWithCount,
    saveToHistory,
    totalCounts,
    stateData,
    companyData,
    setIsLoading,
    fethAllCompanies,
    fetchAllStatesData,
    fetchAllAlerts,
    setIsCategoriesLoading,
    setIsAlertsLoading,
    setIsCompaniesLoading,
    setIsStatesLoading,
    setTotalCounts,
    fetchAllTypeCompaniesData
}) => {
    const handleApplyDashboardFilter = useCallback(async () => {
        setIsLoading(true);
        try {
            const query = filters.query || API_CONSTANTS.DEFAULT_PROMPT;
            const data = await fetchSemanticRCA2({
                ...filters,
                query
            });

            let categoryData = [];
            categoryData = [
                query,
                {
                    prompt: query,
                    count: data.total_counts,
                    complaintNumbers: data?.complaintNumbers
                }
            ]

            setTotalCounts(categoryData[1].count);

            const newFilters = {
                ...filters,
                query,
                title: query,
                complaintNumbers: data?.complaintNumbers
            };

            updateFilters({ complaintNumbers: data?.complaintNumbers });

            // Set granular loading states
            if (setIsCategoriesLoading) setIsCategoriesLoading(true);
            if (setIsStatesLoading) setIsStatesLoading(true);
            if (setIsCompaniesLoading) setIsCompaniesLoading(true);
            if (setIsAlertsLoading) setIsAlertsLoading(true);

            // Execute fetches in parallel
            const fetchStatesPromise = fetchAllStatesData(categoryData, data?.complaintNumbers, newFilters)
                .finally(() => { if (setIsStatesLoading) setIsStatesLoading(false); });

            // const fetchCompaniesPromise = fethAllCompanies(categoryData, data?.complaintNumbers, newFilters)
            //     .finally(() => { if (setIsCompaniesLoading) setIsCompaniesLoading(false); });
            const fetchCompaniesPromise = fetchAllTypeCompaniesData(categoryData, data?.complaintNumbers, newFilters)
                .finally(() => { if (setIsCompaniesLoading) setIsCompaniesLoading(false); });

            const fetchCategoriesAndAlertsPromise = (async () => {
                try {
                    const updatedCategories = await fetchCategories(categoryData, newFilters);
                    if (setIsCategoriesLoading) setIsCategoriesLoading(false);

                    // Handle empty subcategories response
                    if (!updatedCategories || Object.keys(updatedCategories).length === 0) {
                        console.warn('No subcategories found for query:', query);
                        if (setIsAlertsLoading) setIsAlertsLoading(false);
                        return;
                    }

                    await fetchAllAlerts(data?.complaintNumbers, updatedCategories, newFilters);
                } catch (err) {
                    console.error("Error in categories/alerts fetch:", err);
                } finally {
                    if (setIsCategoriesLoading) setIsCategoriesLoading(false);
                    if (setIsAlertsLoading) setIsAlertsLoading(false);
                }
            })();

            await Promise.all([fetchStatesPromise, fetchCompaniesPromise, fetchCategoriesAndAlertsPromise]);

            const searchParams = {
                ...createSearchParams({ ...filters, query, title: query }),
                complaint_numbers: data?.complaintNumbers
            };
            searchParams.total_counts = categoryData[1].count;
            searchParams.prompt = query;
            saveToHistory(searchParams);
        } finally {
            setIsLoading(false);
        }
    }, [
        filters,
        updateFilters,
        fetchSemanticRCA2,
        fetchSpatialData,
        fetchAllCompanyDetails,
        fetchUserData,
        fetchCategories,
        // fetchCategoryWithCount,
        saveToHistory,
        totalCounts,
        stateData,
        setIsLoading,
        setIsCategoriesLoading,
        setIsAlertsLoading,
        setIsCompaniesLoading,
        setIsStatesLoading
    ]);

    return { handleApplyDashboardFilter };
};